import { Pipe, PipeTransform } from '@angular/core';
import { AttributeDefinition } from 'src/app/models/server/attribute-definition';

@Pipe({
    name: 'avmAttributeFilterSubstring',
    standalone: true,
})
export class AvmAttributeFilterSubstringPipe implements PipeTransform {
    transform(attributeFilter: AttributeDefinition, values: any, maxChars: number = 10): string {
        let result: string = '';

        if (attributeFilter.values) {
            if (values) {
                (values as string[]).forEach((x) => {
                    if (result.length > 0) {
                        result += ', ';
                    }

                    result += attributeFilter.values.find((a) => a.value === x).text;
                });
            }
        } else {
            if (values) {
                result = values as string;
            }
        }

        return this.substringResultValue(result, maxChars);
    }

    private substringResultValue(resultValue: string, maxChars: number): string {
        if (resultValue.length > maxChars) {
            return resultValue.substring(0, maxChars - 3) + '...';
        } else {
            return resultValue;
        }
    }
}
